import React from 'react';
import { Box, Paper, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { t } from '../../../utils/textUtils';

const TasksToday = ({ dashboardOverviewData, todayTasks }) => {
  return (
    <Box>
      <Paper
        variant="outlined"
        sx={{ 
          p: { xs: 2, sm: 3 }, 
          borderRadius: 2, 
          borderColor: 'divider',
          bgcolor: '#ffffff',
          minHeight: '450px'
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 1
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a' }}>
            {t('TUGAS HARI INI')}
          </Typography>
          <Button 
            size="small" 
            component={Link} 
            to="/tasks"
            endIcon={<ArrowForwardIosIcon fontSize="small" />}
            sx={{ 
              color: '#0f172a',
              '&:hover': { bgcolor: '#F8FAFC' }
            }}
          >
            {t('LIHAT SEMUA')}
          </Button>
        </Box>
        
        {(dashboardOverviewData.todaysTasks || todayTasks).length > 0 ? (
          <List sx={{ py: 0 }}>
            {(dashboardOverviewData.todaysTasks || todayTasks).map((task, index) => (
              <ListItem 
                key={task.id || `task-${index}`} 
                sx={{ 
                  px: 1, 
                  borderBottom: index < (dashboardOverviewData.todaysTasks || todayTasks).length - 1 ? '1px solid' : 'none',
                  borderColor: 'divider',
                  '&:hover': { bgcolor: '#F8FAFC' }
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <AssignmentIcon sx={{ color: '#FF9800' }} />
                </ListItemIcon>
                <ListItemText 
                  primary={task.name} 
                  secondary={task.projectName || 'TIDAK ADA PROYEK'}
                  primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />
                <Button 
                  size="small" 
                  variant="outlined"
                  sx={{ 
                    minWidth: 'auto', 
                    borderColor: '#FF9800', 
                    color: '#FF9800',
                    '&:hover': { 
                      borderColor: '#FF9800', 
                      bgcolor: 'rgba(255, 152, 0, 0.04)' 
                    }
                  }}
                >
                  {t('MULAI')}
                </Button>
              </ListItem>
            ))}
          </List>
        ) : (
          <Box sx={{ py: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {t('TIDAK ADA TUGAS YANG DITETAPKAN UNTUK HARI INI')}
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default TasksToday;
